import { Image, message, Table } from "antd";
import React, { useContext, useState } from "react";
import { LayoutContext } from "../../Context/LayoutContext/LayoutContext";
import { AuthContext } from "../../Context/AuthContext/AuthContext";
import { server } from "../../utils/fetch";
import { fetchContact } from "../../utils/api-calls/contactCalls";
import AdminReservationEdit from "./AdminReservationEdit";
import { fetchReservation } from "../../utils/api-calls/reservation";

const AdminReservation = () => {
  let url = `${server}/reservation`;
  const { authUser, reservation, setReservation, apartments } = useContext(AuthContext);
  const { topSheet, setTopSheet, setTopSheetContent } =
    useContext(LayoutContext);


  const tableItemEdit = (record) => {};

  const tableItemDelete = async (record) => {
    try {
      const res = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: record.id }),
      });
      const data = await res.json();
      if (res.status == 200 || res.status == 201) {
        let reservationf = await fetchReservation();
        setReservation(reservationf);
        return message.success(data.message);
      }

      return message.error(data.message);
    } catch (error) {
      message.error(`Deleting Failed!`);
    }
  };
  const setSeen = async (record) => {
    try {
      const res = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...record, seen: "true" }),
      });
      const data = await res.json();
      if (res.status == 200 || res.status == 201) {
        let reservationf = await fetchReservation();
        setReservation(reservationf);
        return;
      }
    } catch (error) {}
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      responsive: ["lg"],
      render: (text, record) => (
        <div className="category-table-name">{text}</div>
      ),
    },

    {
      title: "Apartment Name",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <div className="category-table-name">{text}</div>
      ),

    },

    {
      title: "View",
      key: "view",
      render: (text, record) => (
        <button
          className="np-admin-main-button"
          onClick={() => {
            setSeen(record);

            setTopSheetContent(
              <AdminReservationEdit
                method="PUT"
                updateData={reservation.find((data) => data.id == record.id)}
                url={url}
              />
            );
            setTopSheet(true);
            tableItemEdit(record);
          }}
        >
          View
        </button>
      ),
    },
    {
      title: "Delete",
      key: "delete",
      render: (text, record) => (
        <button
          className="np-admin-main-button"
          onClick={() => tableItemDelete(record)}
        >
          Delete
        </button>
      ),
    },
  ];

  return (
    <div className="admin-store-category">
      <div className="page-heading">
        {/* <button
          className="np-admin-main-button add-button"
          onClick={() => {
            setTopSheetContent(<AdminReservationEdit method="POST" url={url} />);
            setTopSheet(true);
          }}
        >
          Add Reservation
        </button> */}
        <Table
          dataSource={reservation.sort((a,b)=> new Date(a.date) - new Date(b.date))}
          rowClassName={(record, index) => {
            return record.seen == "false" ? "set-unseen-row" : "";
          }}
          columns={columns}
        />
      </div>
    </div>
  );
};

export default AdminReservation;
